module.exports = __webpack_public_path__ + "img/full7-min.19dee7f8.png";